import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import RegOptionsStore from '../../../stores/RegOptionsStore';
import SnackStore from '../../../stores/SnackStore';
import FuseConfirmationModal from '../../ConfirmationModal/FuseConfirmationModal';
import FuseButton from '../../FuseControls/FuseButton';
import { FTBody } from '../../Fuse';
import FuseConsoleModal from '../../ConsoleModal/FuseConsoleModal';
import Card from '../../Fuse/Card';
import FuseInfoTooltip from '../../FuseControls/FuseTooltip/FuseInfoTooltip';
import UrlBulkEditor from '../../BulkEditor/UrlBulkEditor';
import IpRegStore from '../../../stores/IpRegStore';
import './IpRangesModal.css';

const block = b.lock('IpRangesModal');

class IpRangesModal extends Component {
    static propTypes = {
        ipReg: IpRegStore.PropType.isRequired,
        regOptions: RegOptionsStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    constructor(props) {
        super(props);
        this.cardRef = React.createRef();
    }

    componentDidMount() {
        const { ipReg } = this.props;

        this.trackCardWidthInterval = setInterval(() => {
            if (this.cardRef.current) {
                clearInterval(this.trackCardWidthInterval);
                ipReg.ipsBulkEditor.updateWidth(this.cardRef.current.offsetWidth);
            }
        }, 100);
    }

    onSaveClick = () => {
        const { snack, ipReg, regOptions } = this.props;
        ipReg.verifyIpRanges()
            .then(() => ipReg.save()
                .then((data) => {
                    regOptions.setIpReg(data);
                    snack.showSuccess(<span><b key={'bold'}>Associated IP Ranges</b> has been saved.</span>);
                })
                .catch(() => snack.showError('Your request could not be processed. Please try again')),
            )
            .catch((e) => snack.showError(e.message));
    };

    renderHeaderAction = () => {
        const { ipReg } = this.props;

        return <FuseButton
            style={{ minWidth: 100 }}
            color={'green'}
            primary
            disabled={!ipReg.hasChanged || !ipReg.ipsBulkEditor.bulkEditorStore.isValid()}
            loading={ipReg.saveStatus.isLoading || ipReg.verifyStatus.isLoading}
            onClick={this.onSaveClick}
        >Save</FuseButton>;
    };

    render() {
        const { ipReg } = this.props;

        return <FuseConsoleModal
            isOpen={ipReg.modal.isOpen}
            onClose={ipReg.close}
            title="Edit Associated IP Ranges"
            className={block()}
            contentClassName={block('Content')}
            headerActions={this.renderHeaderAction()}
        >
            <Card
                title={<div className={block('CardHeader')}>
                    Associated IP Ranges
                    <FuseInfoTooltip>
                        These IP addresses will be used to automatically register a browser if there is a match.
                        All resulting browser traffic will be anonymized.
                    </FuseInfoTooltip>
                </div>}
            >
                <FTBody>Enter IP Addresses below (1 entry per line).</FTBody>

                <div ref={this.cardRef} className={block('BulkEditorContainer')}>
                    <UrlBulkEditor
                        cardWrapperClassName={block('BulkEditorCardWrapperContainer')}
                        cardClassName={block('BulkEditorCardContainer')}
                        validUrlText={'Entries'}
                        placeholder={'Enter or paste IP ranges'}
                        errorMassage={'The following IP ranges are invalid. Please correct and try again.'}
                        warningMessage={'Duplicate IP ranges will be deleted on save'}
                        store={ipReg.ipsBulkEditor}
                    />
                </div>
            </Card>

            <FuseConfirmationModal
                store={ipReg.exitConfirmationModal}
                onConfirm={ipReg.modal.close}
            />
        </FuseConsoleModal>;
    }
}

export default inject('snack', 'ipReg', 'regOptions')(observer(IpRangesModal));
